import { Context, Schema, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import { ChatAttachment, type ChatAttachmentMime } from "@workerstation/shared/chat-contract";
export const ComposerSnapshot = Schema.Struct({ scopeKey: Schema.String, attachments: Schema.Array(ChatAttachment), submitting: Schema.Boolean, closed: Schema.Boolean });
export type ComposerSnapshot = typeof ComposerSnapshot.Type;
export interface ComposerInput {
  readonly scopeKey: string;
  readonly value: string;
  readonly disabled: boolean;
  readonly busy: boolean;
  readonly send: (text: string, attachments: readonly ChatAttachment[]) => Effect.Effect<void | boolean>;
  readonly error: (message: string) => Effect.Effect<void>;
}
export class ChatFileIo extends Context.Service<ChatFileIo, {
  readonly prefix: (file: File) => Effect.Effect<Uint8Array | null>;
  readonly dataUrl: (file: File, mime: ChatAttachmentMime) => Effect.Effect<string>;
  readonly identity: (length: number) => Effect.Effect<string>;
}>()("workerstation/frontend/ChatFileIo") {}
export interface ComposerSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ComposerSnapshot>>;
  readonly read: Effect.Effect<ComposerSnapshot>;
  readonly receive: (input: ComposerInput) => Effect.Effect<void>;
  readonly attach: (scopeKey: string, files: readonly File[]) => Effect.Effect<void>;
  readonly remove: (scopeKey: string, id: string) => Effect.Effect<void>;
  readonly submit: (scopeKey: string) => Effect.Effect<void>;
}
export class ComposerSessions extends Context.Service<ComposerSessions, {
  readonly open: Effect.Effect<ComposerSession, never, Scope.Scope>;
}>()("workerstation/frontend/ComposerSessions") {}
